/** When your routing table is too long, you can split it into small modules**/



export default [
  {
    path: '/transfer-request',
    name: 'TransferRequest',
    component: () => import('@/views/transfers/Request'),
  }, {
    path: '/transfer-qom',
    name: 'TransferQom',
    component: () => import('@/views/transfers/Qom'),
  }, {
    path: '/transfer-ostan',
    name: 'TransferOstan',
    component: () => import('@/views/transfers/Ostan'),
  }, {
    path: '/transfer-history',
    name: 'TransferHistory',
    component: () => import('@/views/transfers/Index'),
  }]
